import React from 'react';
import { Chip } from '@mui/material';

const severityStyles = {
  healthy: { backgroundColor: '#dff0d8', color: '#3c763d' },
  info: { backgroundColor: '#d9edf7', color: '#31708f' },
  warning: { backgroundColor: '#fcf8e3', color: '#8a6d3b' },
  degraded: { backgroundColor: '#fff4e5', color: '#8a4b10' },
  critical: { backgroundColor: '#f2dede', color: '#a94442' },
  severe: { backgroundColor: '#ead1dc', color: '#6d1b24' },
  resolved: { backgroundColor: '#eeeeee', color: '#616161' }
};

const SeverityBadge = ({ severity }) => {
  const key = String(severity || '').toLowerCase();
  const style = severityStyles[key] || severityStyles.info;

  return (
    <Chip
      label={severity}
      size="small"
      sx={{
        textTransform: 'capitalize',
        fontWeight: 600,
        ...style
      }}
    />
  );
};

export default SeverityBadge;
